module.exports = __webpack_public_path__ + "static/media/S (119).2048265f.jpg";